import React from "react"

import { Wrapper, Text } from "./style"

const Header = ({ title, subtitle }) => (
  <Wrapper>
    <Text>
      <h1>{title}</h1>
      <h4>{subtitle}</h4>
    </Text>
  </Wrapper>
)

export default Header
